export default __webpack_public_path__ + "static/backgimage-c4f858c6255d0d884ada3a131972a2e7.webp";